<div class="buy-olx-ads-bundles crm-scroll">
  <div class="buy-olx-ads-bundles-wrapper">
    <ng-container *ngTemplateOutlet="titleTemplate" />

    @if (loaders.ads_bundles) {
      <ng-container *ngTemplateOutlet="singleSkeletonTemplate" />
      <ng-container *ngTemplateOutlet="multiSkeletonTemplate" />
    }

    @if (adsBundles) {
      <ng-container *ngTemplateOutlet="singleContentTemplate" />
      <ng-container *ngTemplateOutlet="multiContentTemplate" />
    }

    <ng-container *ngTemplateOutlet="actionsTemplate" />
    <ng-container *ngTemplateOutlet="loaderTemplate" />
  </div>
</div>

<ng-template #titleTemplate>
  <div class="buy-olx-ads-bundles-title-container">
    <span class="buy-olx-ads-bundles-title">{{ 'buy_olx_ads_bundles.select_paid_services' | translate }}</span>
    @if (baseService.isMobile) {
      <app-button (onChangeClick)="onCloseSidebar()" btnType="icon">
        <app-icon>close</app-icon>
      </app-button>
    }
  </div>
</ng-template>

<!-- SINGLE -->
<ng-template #singleContentTemplate>
  @if (!Array.isArray(adsBundles)) {
    <div class="buy-olx-ads-bundles-content-single">
      <div class="buy-olx-ads-bundles-content-title">{{ adverts[0].title }}</div>

      <mat-card class="buy-olx-ads-bundles-content-card">
        <div class="buy-olx-ads-bundles-content-card-title">{{ 'buy_olx_ads_bundles.bundles' | translate }}</div>
        <div class="buy-olx-ads-bundles-content-single-bundles">
          @for (bundle of adsBundles.bundles; track $index) {
            <div
              class="buy-olx-ads-bundles-content-single-bundle-card"
              [ngClass]="{ selected: isSelected(adverts[0].id, bundle.product_id, BundleSourceType.Bundle) }"
              (click)="onToggle(getSingleAdStub(), bundle, BundleSourceType.Bundle)"
            >
              @if (bundle.product_id === 'bundle_optimum') {
                <div class="buy-olx-ads-bundles-content-single-bundle-card-badge">
                  {{ 'buy_olx_ads_bundles.most_popular' | translate }}
                </div>
              }

              <div class="buy-olx-ads-bundles-content-single-bundle-card-header">
                <div>{{ bundle.label }}</div>
                <div class="buy-olx-ads-bundles-content-single-bundle-card-price">
                  {{ bundle.pricing.regular.raw / 100 | number: '1.2-2' }} {{ 'UAH' | translate }}.
                </div>
              </div>

              <div class="buy-olx-ads-bundles-content-single-bundle-card-features">
                @for (f of bundle.features; track $index) {
                  @if (f.enabled) {
                    <div class="feature">
                      {{ f.label.template }}
                    </div>
                  }
                }
              </div>
            </div>
          }
        </div>
      </mat-card>

      <mat-card class="buy-olx-ads-bundles-content-card">
        <div class="buy-olx-ads-bundles-content-card-title">{{ 'buy_olx_ads_bundles.vas' | translate }}</div>
        <div class="buy-olx-ads-bundles-content-single-vas-list">
          @for (vas of adsBundles.vas_list; track $index) {
            <div
              class="buy-olx-ads-bundles-content-single-vas-item"
              [ngClass]="{ selected: isSelected(adverts[0].id, vas.product_id, BundleSourceType.Vas) }"
              (click)="onToggle(getSingleAdStub(), vas, BundleSourceType.Vas)"
            >
              {{ vas.description.template }}
              <span
                [ngClass]="{ 'text-danger inaccurate-price': vas.is_crm }"
                [matTooltip]="vas.is_crm && ('buy_olx_ads_bundles.inaccurate_price' | translate)"
              >
                {{ vas.pricing.regular.raw / 100 | number: '1.2-2' }}
                {{ 'UAH' | translate }}.
                @if (vas.is_crm) {
                  <app-icon>warning</app-icon>
                }
              </span>
            </div>
          }
        </div>
      </mat-card>
    </div>
  }
</ng-template>

<!-- MULTI -->
<ng-template #multiContentTemplate>
  @if (Array.isArray(adsBundles)) {
    <div class="buy-olx-ads-bundles-content-multi">
      <mat-card class="buy-olx-ads-bundles-content-card">
        <table class="buy-olx-ads-bundles-content-multi-table">
          <thead>
            <tr>
              <th></th>
              @for (type of bundlesTypes; track $index) {
                <th>
                  {{ type.label }}
                  <div class="buy-olx-ads-bundles-content-multi-sub-label" (click)="selectAll(type)">
                    {{ 'buy_olx_ads_bundles.apply_to_all' | translate }}
                  </div>
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (ad of adsBundles; track $index) {
              <tr>
                @let advert = getAdvertById(ad.ad_id);

                @if (advert) {
                  <td [attr.data-label]="'buy_olx_ads_bundles.advert_title' | translate">
                    <div class="buy-olx-ads-bundles-content-multi-advert">
                      @if (advert.images?.[0]?.url) {
                        <img
                          class="buy-olx-ads-bundles-content-multi-advert-image"
                          [src]="$safeNavigationMigration(advert.images?.[0]?.url)"
                          alt="ad image"
                        />
                      }
                      <div class="buy-olx-ads-bundles-content-multi-advert-title">
                        {{ ad.ad_title }}
                      </div>
                    </div>
                  </td>

                  @for (type of bundlesTypes; track $index) {
                    <td [attr.data-label]="type.label">
                      @let bundle = getBundle(ad, type.product_id);

                      @if (bundle) {
                        <app-checkbox
                          [checked]="isSelected(ad.ad_id, bundle.product_id, type.source)"
                          (change)="onToggle(ad, bundle, type.source)"
                        >
                          {{ bundle.pricing.regular.raw / 100 | number: '1.2-2' }} {{ 'UAH' | translate }}.
                        </app-checkbox>
                      }
                    </td>
                  }
                }
              </tr>
            }
          </tbody>
        </table>
      </mat-card>
    </div>
  }
</ng-template>

<ng-template #actionsTemplate>
  <div class="buy-olx-ads-bundles-actions-container">
    <mat-card class="buy-olx-ads-bundles-actions">
      <app-button btnType="cancel" (onChangeClick)="onCloseSidebar()">
        {{ 'cancel' | translate }}
      </app-button>
      <div class="buy-olx-ads-bundles-actions-save-container">
        @if (!plannerId) {
          <app-button
            [disabled]="!totalPrice"
            btnType="icon"
            [matTooltip]="'plan_now' | translate"
            (onChangeClick)="onOpenPlanner()"
          >
            <app-icon>calendar_month</app-icon>
          </app-button>
        }
        <app-button [disabled]="!totalPrice" (onChangeClick)="plannerId ? onUpdatePlanner() : onBuyAdsBundles()">
          {{ (plannerId ? 'buy_olx_ads_bundles.update' : 'buy_olx_ads_bundles.pay') | translate }}
          ({{ totalPrice | number: '1.2-2' }} {{ 'UAH' | translate }})
        </app-button>
      </div>
    </mat-card>
  </div>
</ng-template>

<ng-template #singleSkeletonTemplate>
  @if (adverts.length === 1) {
    <div class="buy-olx-ads-bundles-content-single">
      <div class="buy-olx-ads-bundles-content-title">
        <ngx-skeleton-loader appearance="line" [theme]="{ width: '60%', height: '24px' }" />
      </div>

      <mat-card class="buy-olx-ads-bundles-content-card">
        <div class="buy-olx-ads-bundles-content-card-title">
          <ngx-skeleton-loader appearance="line" [theme]="{ width: '160px', height: '24px' }" />
        </div>

        <div class="buy-olx-ads-bundles-content-single-bundles">
          @for (_ of Array(3); track $index) {
            <div class="buy-olx-ads-bundles-content-single-bundle-card">
              <div class="buy-olx-ads-bundles-content-single-bundle-card-header">
                <ngx-skeleton-loader appearance="line" [theme]="{ width: '35%', height: '20px' }" />
                <ngx-skeleton-loader appearance="line" [theme]="{ width: '15%', height: '20px' }" />
              </div>

              <div class="buy-olx-ads-bundles-content-single-bundle-card-features">
                @for (_ of Array(3); track $index) {
                  <div>
                    <ngx-skeleton-loader appearance="line" [theme]="{ width: '50%', height: '14px' }" />
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </mat-card>

      <mat-card class="buy-olx-ads-bundles-content-card">
        <div class="buy-olx-ads-bundles-content-card-title">
          <ngx-skeleton-loader appearance="line" [theme]="{ width: '160px', height: '24px' }" />
        </div>

        <div class="buy-olx-ads-bundles-content-single-vas-list">
          @for (_ of Array(3); track $index) {
            <div class="buy-olx-ads-bundles-content-single-vas-item">
              <ngx-skeleton-loader appearance="line" [theme]="{ width: '80%', height: '16px' }" />
              <ngx-skeleton-loader appearance="line" [theme]="{ width: '50px', height: '16px' }" />
            </div>
          }
        </div>
      </mat-card>
    </div>
  }
</ng-template>

<ng-template #multiSkeletonTemplate>
  @if (adverts.length > 1) {
    <div class="buy-olx-ads-bundles-content-multi">
      <mat-card class="buy-olx-ads-bundles-content-multi-card">
        <table class="buy-olx-ads-bundles-content-multi-table">
          <thead>
            <tr>
              <th>
                <ngx-skeleton-loader appearance="line" [theme]="{ width: '160px', height: '20px' }" />
              </th>
              @for (_ of Array(5); track $index) {
                <th>
                  <ngx-skeleton-loader appearance="line" [theme]="{ width: '100px', height: '20px' }" />
                  <div class="buy-olx-ads-bundles-content-multi-sub-label">
                    <ngx-skeleton-loader appearance="line" [theme]="{ width: '80px', height: '14px' }" />
                  </div>
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (_ of Array(adverts.length); track $index) {
              <tr>
                <td>
                  <ngx-skeleton-loader appearance="line" [theme]="{ width: '140px', height: '20px' }" />
                </td>
                @for (_ of Array(5); track $index) {
                  <td>
                    <div class="buy-olx-ads-bundles-content-multi-checkbox">
                      <ngx-skeleton-loader
                        appearance="line"
                        [theme]="{ width: '18px', height: '18px', 'margin-right': '4px' }"
                      />
                      <ngx-skeleton-loader appearance="line" [theme]="{ width: '60px', height: '18px' }" />
                    </div>
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </mat-card>
    </div>
  }
</ng-template>

<ng-template #loaderTemplate>
  @if (loaders.buy_ads_bundles) {
    <ngx-skeleton-loader class="skeleton-overlay" animation="pulse" [theme]="{ width: '100%', height: '100%' }" />
  }
</ng-template>
